// extracted by mini-css-extract-plugin
export default {"root":"trigger_root__M7Nwl","trigger_normal":"trigger_trigger_normal__H-tTL","trigger_pushed":"trigger_trigger_pushed__pGUkR"};